import { useState } from 'react';
import { Card, Button, Space, Typography, theme as antdTheme } from 'antd';
import { PurgeUserModal, SectionHeader } from '@viq-admin/ui';
import { Can } from '../../ability/AbilityContext';
import { purgeUser } from '../../api/users';

/**
 * The irreversible action for a user, at the bottom of the user page: Purge,
 * gated on `manage User` — a `super_admin_readonly` sees nothing. Purge opens
 * the INJECTED `@viq-admin/ui` PurgeUserModal with `api/users`' `purgeUser` as
 * its `onPurge`; the super-admin signature already matches the modal's
 * contract, so no adapter is needed.
 *
 * Deactivate / Reactivate used to live here too. They are reversible and
 * everyday, so they moved to the page header (UserHeaderActions); only the
 * action that cannot be undone stays down here, behind the red border.
 */
interface Props {
  oid: string;
  displayName: string;
  onPurged: () => void;
}

export function DangerZone({ oid, displayName, onPurged }: Props) {
  const [purgeOpen, setPurgeOpen] = useState(false);
  const { token } = antdTheme.useToken();

  return (
    <Can I="manage" a="User" passThrough>
      {(allowed: boolean) =>
        allowed ? (
          <Card style={{ borderColor: token.colorError }}>
            <SectionHeader style={{ color: token.colorError }}>
              Danger Zone
            </SectionHeader>
            <Space direction="vertical" size={8}>
              <Typography.Text type="secondary">
                Permanently removes the account, profile and assignments. Captures stay,
                anonymized. This cannot be undone.
              </Typography.Text>
              <Button danger onClick={() => setPurgeOpen(true)}>
                Purge User
              </Button>
            </Space>
            <PurgeUserModal
              oid={oid}
              displayName={displayName}
              open={purgeOpen}
              onClose={() => setPurgeOpen(false)}
              onPurged={onPurged}
              onPurge={purgeUser}
            />
          </Card>
        ) : null
      }
    </Can>
  );
}
